import carEvents from './../config/carEvents';
import {carStates} from '../cars-routes';

export default function CarsHeaderController(
    $scope,
    $state,
    $window,
    $rootScope,
    l10nService,
    carsFactory
) {
    'ngInject';

            const formats = carsFactory.formats;
            const searchResults = carsFactory.getSearchResults();
            const BOOTSTRAP_MOBILE_BREAKPOINT = 768;
            let backup;
            const vm = this;
            Object.assign(vm, {
                showHeader: null,
                $onInit,
                toggleHeader,
                onDateSelect,
            });

            function $onInit() {
                vm.showHeader = true;
                watch();
            }

            function onDateSelect() {
                if (isMobile()) {
                    vm.isReturnCalendarOpenedMobile = true;
                } else {
                    vm.isReturnCalendarOpenedDesktop = true;
                }
            }

            function isMobile() {
                return $window.innerWidth <= BOOTSTRAP_MOBILE_BREAKPOINT;
            }

            function toggleHeader() {
                $scope.carsRequestData = angular.copy(carsFactory.carsRequestData);
                vm.showHeader = !vm.showHeader;
            }

            function watch() {
                $scope.$watch(() => carsFactory.getSearchResults(), refreshData);

                function refreshData(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    $scope.resultsCount = getResultsCount(newVal);
                    $scope.rentalPeriod = getRentalPeriod(newVal);
                }
            }

            $scope.originalRequest = carsFactory.getFormData();

            $scope.MapText = false;
            $scope.carsRequestData = angular.copy(carsFactory.carsRequestData);

            $scope.pickUpDateSettings = angular.copy($scope.carsRequestData.pickUp.date.pickerSettings);
            $scope.dropOffDateSettings = angular.copy($scope.carsRequestData.dropOff.date.pickerSettings);
            $scope.pickUpDateSettings.callback = function(date) {
                $scope.carsRequestData.adjustDates({pickUpDate: date});
            };
            $scope.dropOffDateSettings.callback = function(date) {
                $scope.carsRequestData.adjustDates({dropOffDate: date});
            };

            function getResultsCount(results) {
                return (results.filteredTotal >= 0)
                    ? results.filteredTotal
                    : results.total;
            }

            $scope.resultsCount = getResultsCount(searchResults);

            $rootScope.pageHeading = l10nService.localize('Cars') + ' (' + $scope.resultsCount + ')';

            const scopeRequestData = $scope.carsRequestData;
            const factoryRequestData = carsFactory.carsRequestData;

            scopeRequestData.pickUp.setDateTime($scope.originalRequest.PickUpDate);
            scopeRequestData.pickUp.location.address = $scope.originalRequest.PickUpAddress;
            scopeRequestData.pickUp.location.altAddress = $scope.originalRequest.PickUpAddress;
            scopeRequestData.pickUp.location.longitude = $scope.originalRequest.PickUpLongitude;
            scopeRequestData.pickUp.location.latitude = $scope.originalRequest.PickUpLatitude;
            scopeRequestData.pickUp.location.isAirport = $scope.originalRequest.IsPickupLocationAirport;
            scopeRequestData.dropOff.setDateTime($scope.originalRequest.DropOffDate);
            scopeRequestData.dropOff.location.address = $scope.originalRequest.DropOffAddress;
            scopeRequestData.dropOff.location.altAddress = $scope.originalRequest.DropOffAddress;
            scopeRequestData.dropOff.location.longitude = $scope.originalRequest.DropOffLongitude;
            scopeRequestData.dropOff.location.latitude = $scope.originalRequest.DropOffLatitude;
            scopeRequestData.dropOff.location.isAirport = $scope.originalRequest.IsDropOffLocationAirport;

            if (!factoryRequestData.pickUp.date.value) {
                factoryRequestData.pickUp.date.value = scopeRequestData.pickUp.date.value;
                factoryRequestData.dropOff.date.value = scopeRequestData.dropOff.date.value;
                factoryRequestData.pickUp.location = scopeRequestData.pickUp.location;
                factoryRequestData.dropOff.location = scopeRequestData.dropOff.location;
                factoryRequestData.isUserOutOfRange = scopeRequestData.isUserOutOfRange;
                factoryRequestData.pickUp.time = scopeRequestData.pickUp.time;
                factoryRequestData.dropOff.time = scopeRequestData.dropOff.time;
            }

            $scope.dropOffSameAsPickUp
                = $scope.carsRequestData.pickUp.location.address === $scope.carsRequestData.dropOff.location.address;

            if ($scope.dropOffSameAsPickUp) {
                $scope.carsRequestData.dropOff.clearLocation();
            }

            function getRentalPeriod(results) {
                return results.RentalPeriod;
            }

            $scope.rentalPeriod = getRentalPeriod(searchResults);

            function makeBackup() {
                backup = angular.copy($scope.carsRequestData);
                backup.dropOffSameAsPickUp = $scope.dropOffSameAsPickUp;
            }

            function applyBackup() {
                $scope.carsRequestData = angular.copy(backup);
                $scope.dropOffSameAsPickUp = backup.dropOffSameAsPickUp;
            }

            $scope.toggleMap = function() {
                $scope.MapText = !$scope.MapText;
                $rootScope.$broadcast(carEvents.TRIGGER_MAP_VISIBILITY);
            };

            $scope.scrollToSelected = function(scrolledFlag, $event) {
                const options = $scope.carsRequestData[scrolledFlag].time.options;
                const current = $scope.carsRequestData[scrolledFlag].time.current;
                const target = angular.element($event.target).find('.dropdown').length
                    ? angular.element($event.target).find('.dropdown')
                    : angular.element($event.target).siblings('.dropdown');
                const optionHeight = target.children().first().height();
                const index = _.findIndex(options, function(option) {
                        return option.value === current.value;
                    });

                target.scrollTop((index) * optionHeight);
            };

            $scope.toggleFiltersCars = function() {
                $scope.showFiltersCars = !$scope.showFiltersCars;
                $rootScope.$broadcast(carEvents.TRIGGER_CAR_FILTERS);
            };

            $scope.dropOffSameChanged = function() {
                $scope.carsRequestData.dropOff.clearLocation();
            };

            $scope.setPickUpTime = function(val) {
                $scope.carsRequestData.adjustDates({pickUpTime: val});
                const timeOptsAmount = $scope.carsRequestData.defaultTimeOptions.length - 1;
                $scope.pickUpDateSettings.shiftDependentDays = Number(
                    val.value === $scope.carsRequestData.defaultTimeOptions[timeOptsAmount].value
                );
            };

            $scope.setDropOffTime = function(val) {
                $scope.carsRequestData.adjustDates({dropOffTime: val});
            };

            $scope.$watch('showHeader', function(value) {
                if (value) {
                    applyBackup();
                }
            });

            $scope.findCars = function(carsRequestData, originalRequest, dropOffSameAsPickUp) {
                if (dropOffSameAsPickUp) {
                    carsRequestData.dropOff.location = angular.copy(carsRequestData.pickUp.location);
                }

                const requestParams = {
                    Radius: originalRequest.Radius,
                    PickUpLatitude: carsRequestData.pickUp.location.latitude,
                    PickUpLongitude: carsRequestData.pickUp.location.longitude,
                    PickUpAddress: carsRequestData.pickUp.location.altAddress,
                    IsPickupLocationAirport: carsRequestData.pickUp.location.isAirport,
                    DropOffLatitude: carsRequestData.dropOff.location.latitude,
                    DropOffLongitude: carsRequestData.dropOff.location.longitude,
                    DropOffAddress: carsRequestData.dropOff.location.altAddress,
                    IsDropOffLocationAirport: carsRequestData.dropOff.location.isAirport,
                    IsUserAgeOutOfRange: carsRequestData.isUserOutOfRange,
                    PickUpDate: carsRequestData.pickUp.getDateTime().format(formats.dateTime),
                    DropOffDate: carsRequestData.dropOff.getDateTime().format(formats.dateTime),
                    Min: originalRequest.Min,
                    Max: originalRequest.Max,
                    CarSorting: 2,
                };

                carsFactory.resetFilters();
                carsFactory.resetSearchId();
                carsFactory.carsRequestData = angular.copy(carsRequestData);
                makeBackup();
                $state.go(carStates.RESULTS, requestParams, {reload: true});
            };

            makeBackup();
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/carsHeaderCtrl.js